import React from 'react';
import ProgressLabel from '../ProgressLabel';

const ReadyLabel = () => (
    <ProgressLabel text="In Line" color="yellow" />
);

export default ReadyLabel;
